/* unplugin-vue-components disabled */import { render } from "./member_userCard.vue?vue&type=template&id=2afd2cfa&scoped=true"
import script from "./member_userCard.vue?vue&type=script&lang=js"
export * from "./member_userCard.vue?vue&type=script&lang=js"

import "./member_userCard.vue?vue&type=style&index=0&id=2afd2cfa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2afd2cfa"]])

export default __exports__